export default {
	gb: {
		global: {
			gallery: 'Photo gallery',
			locationTitle: 'Location & Contact information',
			apartment: 'Apartment',
		},
		aboutPage: {
			title: 'About Ana',
			intro: "Tucked away in the peaceful Istrian countryside near Kršan, House Ana offers a quiet garden retreat just a short drive from the coast at Rabac and Labin, and about half an hour from Pula and Rijeka.",
			text: "Ana is a cozy apartment for 2+2 guests, with one bedroom, a living room, a bathroom and a fully equipped kitchen. Step outside to a private front porch and a huge garden with an outdoor kitchen and BBQ - perfect for long summer evenings.",
			explore: "Explore the area",
		},
		discover: {
			krsan: "Discover Kršan",
			labin: "Discover Labin & Rabac",
			istria: "Discover Istria",
		},
		services: {
			garden: 'Large private garden',
			petFriendly: 'Pets allowed',
			outdoorKitchen: 'Outdoor kitchen with BBQ',
			porch: 'Front porch',
			ac: 'Air conditioning',
			freeWifi: 'Free WiFi',
			tv: 'TV',
			washer: 'Washing machine',
			bathroom: 'Bathroom',
		},
	},
	hr: {
		global: {
			gallery: 'Foto galerija',
			locationTitle: 'Lokacija i kontakt informacije',
			apartment: 'Apartman',
		},
		aboutPage: {
			title: 'O apartmanu Ana',
			intro: "Smješten u mirnom istarskom zaleđu blizu Kršana, apartman Ana nudi miran odmor u vrtu, samo kratkom vožnjom od obale kod Rapca i Labina, te oko pola sata od Pule i Rijeke.",
			text: "Ana je ugodan apartman za 2+2 gosta, s jednom spavaćom sobom, dnevnim boravkom, kupaonicom i potpuno opremljenom kuhinjom. Izađite na privatni trijem i uživajte u prostranom vrtu s vanjskom kuhinjom i roštiljem - savršeno za duge ljetne večeri.",
			explore: "Istražite okolicu",
		},
		discover: {
			krsan: "Otkrijte Kršan",
			labin: "Otkrijte Labin i Rabac",
			istria: "Otkrijte Istru",
		},
		services: {
			garden: 'Prostrani privatni vrt',
			petFriendly: 'Kućni ljubimci dozvoljeni',
			outdoorKitchen: 'Vanjska kuhinja s roštiljem',
			porch: 'Trijem',
			ac: 'Klima uređaj',
			freeWifi: 'Besplatan WiFi',
			tv: 'TV',
			washer: 'Perilica rublja',
			bathroom: 'Kupaonica',
		},
	},
	de: {
		global: {
			gallery: 'Fotogalerie',
			locationTitle: 'Standort & Kontaktinformationen',
			apartment: 'Wohnung',
		},
		aboutPage: {
			title: 'Über Ana',
			intro: "Eingebettet in die ruhige istrische Landschaft nahe Kršan, bietet die Wohnung Ana einen ruhigen Gartenrückzugsort, nur eine kurze Fahrt von der Küste bei Rabac und Labin entfernt, und etwa eine halbe Stunde von Pula und Rijeka.",
			text: "Ana ist eine gemütliche Wohnung für 2+2 Gäste mit einem Schlafzimmer, einem Wohnzimmer, einem Badezimmer und einer voll ausgestatteten Küche. Treten Sie hinaus auf eine private Veranda und einen riesigen Garten mit Außenküche und Grill - perfekt für lange Sommerabende.",
			explore: "Entdecken Sie die Umgebung",
		},
		discover: {
			krsan: "Entdecken Sie Kršan",
			labin: "Entdecken Sie Labin & Rabac",
			istria: "Entdecken Sie Istrien",
		},
		services: {
			garden: 'Großer privater Garten',
			petFriendly: 'Haustiere erlaubt',
			outdoorKitchen: 'Außenküche mit Grill',
			porch: 'Veranda',
			ac: 'Klimaanlage',
			freeWifi: 'Kostenloses WLAN',
			tv: 'Fernseher',
			washer: 'Waschmaschine',
			bathroom: 'Badezimmer',
		},
	},
	it: {
		global: {
			gallery: 'Galleria fotografica',
			locationTitle: 'Posizione e informazioni di contatto',
			apartment: 'Appartamento',
		},
		aboutPage: {
			title: 'Informazioni su Ana',
			intro: "Immerso nella tranquilla campagna istriana vicino a Kršan, l'appartamento Ana offre un tranquillo rifugio in giardino, a breve distanza in auto dalla costa di Rabac e Labin, e a circa mezz'ora da Pola e Fiume.",
			text: "Ana è un accogliente appartamento per 2+2 ospiti, con una camera da letto, un soggiorno, un bagno e una cucina completamente attrezzata. Uscite sulla veranda privata e godetevi il grande giardino con cucina esterna e barbecue - perfetto per le lunghe serate estive.",
			explore: "Esplora la zona",
		},
		discover: {
			krsan: "Scopri Kršan",
			labin: "Scopri Labin e Rabac",
			istria: "Scopri l'Istria",
		},
		services: {
			garden: 'Ampio giardino privato',
			petFriendly: 'Animali domestici ammessi',
			outdoorKitchen: 'Cucina esterna con barbecue',
			porch: 'Veranda',
			ac: 'Aria condizionata',
			freeWifi: 'WiFi gratuito',
			tv: 'TV',
			washer: 'Lavatrice',
			bathroom: 'Bagno',
		},
	},
};
